export const APP_VERSION = '0.2.0';
export const SESSION_STORAGE_KEY = 'sos.signal.session';
export const USERS = ['user1', 'user2'] as const;

export type Username = (typeof USERS)[number];

export function getOtherUser(currentUser: Username): Username {
  return currentUser === 'user1' ? 'user2' : 'user1';
}
